import { render, staticRenderFns } from "./pad-version.vue?vue&type=template&id=340cec0a&scoped=true"
import script from "./pad-version.vue?vue&type=script&lang=js"
export * from "./pad-version.vue?vue&type=script&lang=js"
import style0 from "./pad-version.vue?vue&type=style&index=0&id=340cec0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340cec0a",
  null
  
)

export default component.exports